// pipes.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThousandsSeparatorPipe } from './thousands-separator.pipe';
import { CustomDatePipe } from './custom-date.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ThousandsSeparatorPipe,
    CustomDatePipe
  ],
  exports: [
    ThousandsSeparatorPipe,
    CustomDatePipe
  ]
})
export class PipesModule { }
